import type { ReactNode } from "react";

export interface NavItem {
  key: string;
  label: string;
  icon: ReactNode;
  badge?: ReactNode;
  current: boolean;
  onSelect: () => void;
}

interface AppShellProps {
  /** "sidebar" (padrão) ou "topbar": a escolha vem da configuração da aplicação, não do componente. */
  layout: "sidebar" | "topbar";
  brand: { name: string; tagline?: string; monogram: string; logoUrl?: string | null };
  nav: NavItem[];
  user: ReactNode;
  topbar?: ReactNode;
  banner?: ReactNode;
  children: ReactNode;
}

/** Casca da aplicação: marca, navegação e área de conteúdo. Não sabe quais telas existem. */
export function AppShell({ layout, brand, nav, user, topbar, banner, children }: AppShellProps) {
  return (
    <div className={`ds-shell${layout === "topbar" ? " ds-shell--topbar" : ""}`}>
      <aside className="ds-shell__sidebar" aria-label="Navegação principal">
        <div className="ds-brand">
          {brand.logoUrl ? <img className="ds-brand__mark" src={brand.logoUrl} alt="" /> : <div className="ds-brand__mark" aria-hidden="true">{brand.monogram}</div>}
          <div>
            <div className="ds-brand__name">{brand.name}</div>
            {brand.tagline ? <div className="ds-brand__tagline">{brand.tagline}</div> : null}
          </div>
        </div>
        <nav className="ds-nav">
          {nav.map((item) => (
            <button key={item.key} type="button" className="ds-nav__item" aria-current={item.current ? "page" : undefined} onClick={item.onSelect}>
              <span className="ds-nav__icon" aria-hidden="true">{item.icon}</span>
              <span>{item.label}</span>
              {item.badge ? <span className="ds-nav__badge">{item.badge}</span> : null}
            </button>
          ))}
        </nav>
        <div className="ds-shell__spacer" />
        <div className="ds-shell__user">{user}</div>
      </aside>
      <main className="ds-shell__main">
        {banner}
        <header className="ds-shell__topbar" data-print="hide">{topbar}</header>
        <div className="ds-shell__content">{children}</div>
      </main>
    </div>
  );
}
